import AppRouter from './routes/AppRouter'

const App = () => (
  <div className="app-shell">
    <AppRouter />
  </div>
)

export default App
